type PermissionCandidate = string | { name?: string; permission?: string } | null | undefined

const permissionAliasMap: Record<string, string> = {
  order: 'orders',
  'order status': 'orders',
  'order-status': 'orders',
}

const normalizePermissionValue = (permission: string): string => {
  const raw = permission.trim().toLowerCase()
  if (!raw) return ''
  return permissionAliasMap[raw] || raw
}

export const normalizePermissions = (permissions: PermissionCandidate[] | undefined | null): string[] => {
  if (!Array.isArray(permissions)) {
    return []
  }

  const normalized = permissions
    .map((entry) => {
      if (typeof entry === 'string') {
        return normalizePermissionValue(entry)
      }

      if (entry && typeof entry === 'object') {
        const candidate = entry.name || entry.permission || ''
        return normalizePermissionValue(candidate)
      }

      return ''
    })
    .filter(Boolean)

  return Array.from(new Set(normalized))
}

export const hasPermission = (permissions: string[] | undefined | null, requiredPermission: string): boolean => {
  const normalizedPermissions = normalizePermissions(permissions)
  const req = normalizePermissionValue(requiredPermission)
  if (!req) return true
  if (normalizedPermissions.length === 0) return false

  return normalizedPermissions.some((p) => {
    const normP = normalizePermissionValue(p)
    return (
      normP === req ||
      normP.startsWith(`${req}:`) ||
      normP.startsWith(`${req}.`) ||
      (req === 'materia_prima' &&
        (normP === 'materia_prima' ||
          normP.startsWith('materia_prima:') ||
          (normP === 'stock' && !normalizedPermissions.includes('insumos') && !normalizedPermissions.includes('resource') && !normalizedPermissions.includes('resources')))) ||
      (req === 'insumos' &&
        (normP === 'resource' || normP === 'resources' || normP === 'insumos' || normP.startsWith('resource:') || normP.startsWith('insumos:'))) ||
      (req === 'produto_engenheirado' &&
        (normP === 'products' || normP === 'produto_engenheirado' || normP.startsWith('products:') || normP.startsWith('produto_engenheirado:'))) ||
      (req === 'orcamentos' && (normP === 'orders' || normP.startsWith('orders:'))) ||
      (req === 'fretes' && (normP === 'router' || normP.startsWith('router:')))
    )
  })
}

export const resolveEffectivePermissions = (
  userPermissions: PermissionCandidate[] | undefined | null,
  sectionPermissions: PermissionCandidate[] | undefined | null,
  profilePermissions?: PermissionCandidate[] | undefined | null,
): string[] => {
  const normalizedUserPermissions = normalizePermissions(userPermissions)
  const normalizedSectionPermissions = normalizePermissions(sectionPermissions)
  const normalizedProfilePermissions = normalizePermissions(profilePermissions)

  return Array.from(
    new Set([
      ...normalizedProfilePermissions,
      ...normalizedSectionPermissions,
      ...normalizedUserPermissions,
    ]),
  )
}
